<ion-modal *ngIf="active" [isOpen]="active" css-class="menu-modal" (didDismiss)="active = false">
    <ng-template>
        <modal-header [title]="title"></modal-header>

        <ion-content class="ion-padding">
            <ion-content>
                <div class="filter">
                    <ion-item>
                        <ion-label position="floating">Filter</ion-label>
                        <ion-input [(ngModel)]="filter"
                                   (ionChange)="callFilter()"></ion-input>
                        <ion-buttons slot="end">
                            <ion-button color="dark" data-cy="create-item-button" (click)="filter = ''">
                                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                            </ion-button>
                            <ion-button color="dark" data-cy="create-item-button" (click)="active = false">
                                Done
                            </ion-button>
                        </ion-buttons>
                    </ion-item>
                    <ion-item (click)="toggleItems()">
                        <ion-checkbox color="primary" slot="start"
                                      [indeterminate]="partialSelected()"
                                      [checked]="allSelected()"></ion-checkbox>
                        <ion-label>{{ !!filter ? 'Select Filtered' : 'Select All' }}</ion-label>
                    </ion-item>
                </div>
                <ion-grid>
                    <ion-row>
                        <ion-col *ngFor="let item of filteredItems" size-xs="12" size-md="6" size-lg="4">
                            <ion-item>
                                <ion-checkbox color="primary" slot="start"
                                              [(ngModel)]="item[selectionParam]"
                                              [disabled]="item[disabledParam]"
                                              (ionChange)="updateInternal()"></ion-checkbox>
                                <ng-template [ngTemplateOutlet]="selectTemplate" [ngTemplateOutletContext]="{$implicit: item}"></ng-template>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-content>
        </ion-content>

        <modal-footer submitLabel="Done" (submitClicked)="active = false"></modal-footer>
    </ng-template>
</ion-modal>
<ion-item>
    <ion-buttons slot="end">
        <ion-button *ngIf="includeAdd" color="dark" (click)="addItemClicked($event)">
            Create
        </ion-button>
        <ion-button *ngIf="!!includeAlphabeticalSort && !!selectedItems && selectedItems.length > 1"
                    color="dark" (click)="sortAlphabetical.emit()">
            Sort Alphabetical
        </ion-button>
        <ion-button color="dark" (click)="active = true">
            Open Selection
        </ion-button>
    </ion-buttons>
</ion-item>
<ion-item *ngIf="internalSelectedItems.length === 0" (click)="active = true">
    None
</ion-item>
<ion-list>
    <ion-reorder-group (ionItemReorder)="reorder($event)" disabled="false">
        <ion-item *ngFor="let item of internalSelectedItems">
            <ng-template [ngTemplateOutlet]="displayTemplate" [ngTemplateOutletContext]="{$implicit: item}"></ng-template>
            <ion-buttons *ngIf="!item[disabledParam]" slot="end">
                <ion-button color="dark" (click)="removeSingle($event, item)">
                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-reorder *ngIf="sortable && internalSelectedItems.length > 1" slot="end"></ion-reorder>
        </ion-item>
    </ion-reorder-group>
</ion-list>
